import { useState } from 'react';
import { Card, CardContent, CardHeader, Typography, TextField, Button, Container } from '@mui/material';
import { createOrganization } from '../../services/organizationService';

export default function NewOrganizationView() {
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');

  const handleSubmit = async () => {
    try {
      createOrganization(name, description).then((response) => {
        console.log(response);
        window.location.reload();
      }).catch((error) => {
        console.error('Failed to create organization:', error);
      });
    } catch (error) {
      console.error('Failed to create organization:', error);
    }
  };

  return (
    <Card>
      <CardHeader title="Create New Organization" />
      <CardContent>
        <Typography variant="body2" sx={{ color: 'text.secondary', mb: 3 }}>
          Create a new organization to collaborate with others.
        </Typography>
        
        <TextField
          fullWidth
          label="Organization Name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          margin="normal"
          required
        />

        <TextField
          fullWidth
          label="Description"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          margin="normal"
          multiline
          rows={4}
        />

        <Container disableGutters sx={{ mt: 3 }}>
          <Button 
            variant="contained" 
            color="primary"
            onClick={handleSubmit}
            disabled={!name}
          >
            Create Organization
          </Button>
        </Container>
      </CardContent>
    </Card>
  );
}
